/* eslint-disable indent */
import { useContext, useMemo } from 'react';

import { Product } from '@src/constants';
import { Store } from '@src/store';

export const useGetProductName = () => {
  const {
    state: {
      stateUser: { selectedProduct },
      stateFormIFLFlat: { selectedIProduct: flatIsuranceProduct },
      stateFormIFLHouse: { selectedIProduct: houseInsuranceProduct },
      stateFormNSSport: { insuranceProduct: sportInsuranceProduct },
      stateFormPets: { selectedIProduct: petsInsuranceProduct },
      statePetsTelevetPlus: { selectedIProduct: televetPlusInsuranceProduct },
      stateMite: { insuranceProductPolicy: miteInsuranceProduct },
      stateFormNS: { insuranceProduct: nsInsuranceProduct },
    },
  } = useContext(Store);

  return useMemo(() => {
    switch (selectedProduct) {
      case Product.HOUSE:
        return houseInsuranceProduct?.name;
      case Product.APARTMENT:
        return flatIsuranceProduct?.name;
      case Product.SPORT:
        return sportInsuranceProduct?.code;
      case Product.PETS:
        return petsInsuranceProduct?.name;
      case Product.MITE:
        return miteInsuranceProduct?.productName;
      case Product.NS:
        return nsInsuranceProduct?.name;
      case Product.PETS_TELEVET_PLUS:
        return televetPlusInsuranceProduct?.name;
      default:
        return undefined;
    }
  }, [selectedProduct]);
};
